import { render, staticRenderFns } from "./FangziHeadTwo.vue?vue&type=template&id=4bf8718b&scoped=true&"
import script from "./FangziHeadTwo.vue?vue&type=script&lang=js&"
export * from "./FangziHeadTwo.vue?vue&type=script&lang=js&"
import style0 from "./FangziHeadTwo.vue?vue&type=style&index=0&id=4bf8718b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf8718b",
  null
  
)

export default component.exports